<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uQWpvf/cover.jpeg?1684229396011" alt="This image is the cover for the book Young Master, Don’t Get Entangled, Volume 6"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Young Master, Don’t Get Entangled, Volume 6
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>The man who had been loved for ten years allowed her to feed the crocodiles, but this was enough for her to return to the time when they met. Good.</strong> </p><p>From now on, she wanted to see who was using who. He didn't expect that after using all of his abilities, this man would actually go after him.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Qing XiaoFu, Lemon Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1e5be13c